import { createContext, useEffect, useState } from "react";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState({});

    useEffect(()=>{
        const persistedData = localStorage.getItem('authSoftdata');
        if (persistedData) {
            setAuth(JSON.parse(persistedData));
        }
    }, []);

    useEffect(() => {
        localStorage.setItem('authSoftdata', JSON.stringify(auth));
      }, [auth]);

    return (
        <AuthContext.Provider value={{ auth, setAuth }}>
            {children}
        </AuthContext.Provider>
    )
}

export default AuthContext;